var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading" }, [
    _c("h3", [_vm._v("PROCESSANDO O PAGAMENTO")]),
    _vm._v(" "),
    _c("div", { class: "loader squeegee" }),
    _vm._v(" "),
    _c("span", { staticClass: "loader-title" }, [
      _c("b", { domProps: { innerHTML: _vm._s(_vm.title) } })
    ]),
    _vm._v(" "),
    _c("span", {
      staticClass: "loader-message",
      domProps: { innerHTML: _vm._s(_vm.message) }
    }),
    _vm._v(" "),
    _c("span", { staticClass: "loader-muted" }, [
      _vm._v("Isto poderá demorar um pouco...")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09e3fd83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09e3fd83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CheckoutMobile/Payment/Components/GifLoader.vue
// module id = null
// module chunks = 